import React from "react";
import { t } from "i18next";

const STATUS_COLORS = {
    "Активные":    { dot: "bg-[#147F26]",  badge: "bg-[#147F26]/10 text-[#147F26]" },
    "Ожидающие":   { dot: "bg-yellow-400", badge: "bg-yellow-50 text-yellow-600" },
    "Неактивные":  { dot: "bg-gray-400",   badge: "bg-gray-100 text-gray-500" },
    "Отклоненные": { dot: "bg-red-500",    badge: "bg-red-50 text-red-500" },
};

export function AdFilterTabButtons(filter, setFilter, counts) {
    const tabs = [
        { key: "Активные",    labelKey: "active",   countKey: "active" },
        { key: "Ожидающие",   labelKey: "pending",  countKey: "pending" },
        { key: "Неактивные",  labelKey: "inactive", countKey: "inactive" },
        { key: "Отклоненные", labelKey: "rejected", countKey: "rejected" },
    ];

    return (
        <div className="flex gap-2 overflow-x-auto scrollbar-none pb-1" style={{ scrollbarWidth: "none" }}>
            {tabs.map(tab => {
                const isActive = filter === tab.key;
                const colors = STATUS_COLORS[tab.key];
                return (
                    <button
                        key={tab.key}
                        onClick={() => setFilter(tab.key)}
                        className={`flex items-center gap-2 px-4 py-2 rounded-xl text-sm font-medium whitespace-nowrap transition-all border
                            ${isActive
                                ? "bg-[#147F26] text-white border-[#147F26] shadow-sm"
                                : "bg-white text-gray-600 border-gray-200 hover:border-gray-300 hover:bg-gray-50"
                            }`}
                    >
                        <span className={`w-1.5 h-1.5 rounded-full flex-shrink-0 ${isActive ? "bg-white" : colors.dot}`} />
                        {t(tab.labelKey)}
                        <span className={`text-xs font-semibold px-1.5 py-0.5 rounded-full min-w-[20px] text-center
                            ${isActive ? "bg-white/20 text-white" : colors.badge}`}>
                            {counts[tab.countKey] || 0}
                        </span>
                    </button>
                );
            })}
        </div>
    );
}
